{
    "Auth0": {
        "Domain": "auth.liquiditycube.trade",
        "ClientId": "zzXvrmAKrI6KTEenaUfrbBC7XfTE9gwH",
        "Audience": "https://liquiditycube.trade/api",
        "Namespace": "https://liquiditycube.net"
    },
    "BaseUrl": "https://api.liquiditycube.trade",
    "BannerUrl": "PROD",
    "MegaPipe": {
        "BaseUrl": "https://megapipe.liquiditycube.trade"
    }
}